import type {
  ReactionDisposeManager,
  WithReactionDispose,
} from '../../../utils/store';
import type {Nullable} from '../../../utils/utility-types';
import type {CategoryModel} from '../../domain/Category/Category.model';
import type {FileModel} from '../../domain/File/File.model';
import type {UserModel} from '../../domain/User/User.model';

export abstract class CurrentUserService implements WithReactionDispose {
  abstract disposer: ReactionDisposeManager;
  abstract fetch: () => Promise<void>;
  abstract getCategoryById: (id: string) => Nullable<CategoryModel>;
  abstract getIsMeFrozenForCourse: (courseId: string) => boolean;
  abstract hasActiveUser: () => Promise<boolean>;
  abstract hasRole: (role: UserModel.Role) => boolean;
  abstract id: string;
  abstract isCoachForEntity: (
    entity: CurrentUserService.CheckIsMeCoachTarget,
  ) => boolean;
  abstract isMyFile: (file: FileModel) => boolean;
  abstract update: (user: UserModel) => Promise<void>;
  abstract user: Nullable<UserModel>;
}

export namespace CurrentUserService {
  export type CheckIsMeCoachTarget = Nullable<{
    coach_ids?: string[];
  }>;
}
